module.exports = __webpack_public_path__ + "img/logoFinalMK-ORIGINAL.a543ba4e.png";